































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as moment from 'moment-mini';

@Component
export default class DateTimePicker extends Vue {
  @Prop({default: 'Date'}) private dateLabel!: string;
  @Prop({default: new Date().toISOString() }) private dateTime!: string;
  private dateMenu: boolean = false;

  private dateTimeUpdated(event: string, field: string) {
    let newDateStr = '';
    if (field === 'date') {
      newDateStr = `${event}${new Date(this.dateTime).toISOString().substr(10)}`;
    } else if (field === 'time') {
      const ampm = event.split(' ')[1];
      let hour = event.split(' ')[0];

      if (ampm === 'PM') {
        hour = (parseInt(event, 10) + 12).toString() + ':00';
      }
      const dateStringWithoutZone = new Date(this.dateTime).toISOString().substr(0, 10) + 'T' + hour;
      newDateStr = `${moment(dateStringWithoutZone).toISOString()}`;
    }
    this.$emit('dateChanged', newDateStr);
  }

  get date(): string {
    return new Date(this.dateTime).toISOString().substr(0, 10);
  }

  get time(): string {
    const date =  new Date(this.dateTime);
    let hours: string | number = date.getHours();
    let minutes: number | string = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    minutes = Math.floor(minutes / 15) * 15;
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    hours = hours < 10 ? '0' + hours : hours;
    return hours + ':' + minutes + ' ' + ampm;
  }

  get generateTimes(): string[] {
    const x = 15;
    const times = [];
    let tt = 360;
    const ap = ['AM', 'PM'];

    // loop to increment the time and push results in array
    for (let i = 0; tt <= 18 * 60; i++) {
      const hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      const mm = (tt % 60); // getting minutes of the hour in 0-55 format
      // pushing data in array in [00:00 - 12:00 AM/PM format]
      times[i] = ('0' + (hh % 12)).slice(-2) + ':' + ('0' + mm).slice(-2) + ' ' + ap[Math.floor(hh / 12)];
      tt = tt + x;
    }

    return times;
  }

}
